import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'

import { STRING } from 'resources'

import profileInfoActions from 'models/ProfileInfo/actions'

import { ModalTitle } from 'components/ReklaimModal'

import { ModalDescription, Button, ErrorText } from './styles'

const RESEND_TIMEOUT_MS = 10000

const EmailAddressAddFailure = ({ pendingEmailAddress, setScreenToEmailConfirmation }) => {
  const dispatch = useDispatch()
  const [canResendVerificationEmail, setCanResendVerificationEmail] = useState(true)
  const [sendVerificationEmailFailed, setSendVerificationEmailFailed] = useState(false)

  const handleResendVerificationEmail = () => {
    setCanResendVerificationEmail(false)
    dispatch(
      profileInfoActions.addEmailAddressSendVerificationEmail.init(pendingEmailAddress, 'protect', (isSuccess) => {
        if (isSuccess) {
          setScreenToEmailConfirmation()
        } else {
          setSendVerificationEmailFailed(true)
        }
      }),
    )
  }

  // Resend Verification Email Timeout
  useEffect(() => {
    if (!canResendVerificationEmail) {
      const timeoutId = setTimeout(() => {
        setCanResendVerificationEmail(true)
        setSendVerificationEmailFailed(false)
      }, RESEND_TIMEOUT_MS)
      return () => clearTimeout(timeoutId)
    }
    return undefined
  }, [canResendVerificationEmail])

  return (
    <>
      <ModalTitle>{STRING.account.addNewEmailAddressModal.emailAddressAddFailure.title}</ModalTitle>
      <ModalDescription>{STRING.account.addNewEmailAddressModal.emailAddressAddFailure.message}</ModalDescription>
      <Button onClick={handleResendVerificationEmail} disabled={!canResendVerificationEmail}>
        {STRING.account.addNewEmailAddressModal.emailAddressAddFailure.button}
      </Button>
      {sendVerificationEmailFailed && (
        <ErrorText>{STRING.account.addNewEmailAddressModal.emailAddressAddFailure.resendFailed}</ErrorText>
      )}
    </>
  )
}

EmailAddressAddFailure.propTypes = {
  pendingEmailAddress: PropTypes.string.isRequired,
  setScreenToEmailConfirmation: PropTypes.func.isRequired,
}

export default EmailAddressAddFailure
